// ANCHOR Next
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

// ANCHOR Graph States
import { useAuthState } from '@lyon/nodes/firebase/auth/auth-state-node';

// ANCHOR Components
import { LyonAppHead } from '@lyon/components/head/LyonAppHead';
import { FullPageLoader } from '@lyon/components/full-page-loader';
import { Redirect } from '@lyon/components/redirect';

const LyonSignInPage = dynamic<any>(
  () => (
    import('@lyon/components/sign-in/LyonSignIn')
      .then((mod) => mod.LyonSignIn)
  ),
  {
    loading: () => <FullPageLoader />,
  },
);

const OPEN_GRAPH = {
  url: 'https://lyon.com.ph/sign-up',
  width: '1366',
  height: '768',
  image: 'https://ucarecdn.com/473f70fe-f413-4cbe-a81c-47fea6642cbf/cplyon.webp',
};

function AuthCheck() {
  const user = useAuthState();
  const router = useRouter();

  const href = String(router.query.redirectUrl || '/profile/me');

  if (typeof user === 'undefined') {
    return <FullPageLoader />;
  }

  if (user) {
    return <Redirect href={href} />;
  }

  return <LyonSignInPage />;
}

// eslint-disable-next-line import/no-default-export
export default function SignIn() {
  return (
    <>
      <LyonAppHead
        title="Lyon | Sign-in"
        description="Join Lyon to get your professional certifications online. Lyon provides online CPD and certifications nationwide."
        openGraph={OPEN_GRAPH}
      />
      <AuthCheck />
    </>
  );
}
